module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"organization":"Organization: {organization}","updatedBy":"Updated by: {updatedBy}","updatedAt":"Updated at: {updatedAtFormatted}","save":"Save"},"es":{"title":{"branding":"Marca","chatUrl":"Urls de Chats","emailSignatures":"Firma de Correos Electrónicos"},"updatedBy":"Actualizado por: {updatedBy}","updatedAt":"Actualizado en: {updatedAtFormatted}","save":"Guardar"}}')
  delete Component.options._Ctor
}
